import { render, staticRenderFns } from "./proportion-cal-n.vue?vue&type=template&id=093d6ae2&scoped=true&lang=pug&"
import script from "./proportion-cal-n.vue?vue&type=script&lang=ts&"
export * from "./proportion-cal-n.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093d6ae2",
  null
  
)

export default component.exports